import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { ExclamationIcon, XIcon } from '@heroicons/react/solid'

// Scammers push people off-platform to Discord/Telegram, then ask for personal
// details or money. Warn whoever is reading, not whoever wrote it.
//
// Swapping contact details is also a normal thing for collaborators to do, so
// this warns and never blocks. The fake-support notice is the opposite shape:
// it is always on, and lives in PrivatePostShow.
const OFF_PLATFORM = /discord|telegram/i

const ScamWarning = ({ text }) => {
  const [closed, setClosed] = useState(false)
  if (closed || !OFF_PLATFORM.test(text || '')) { return null }

  return <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4 my-2">
    <div className="flex">
      <div className="flex-shrink-0 text-yellow-800">
        <ExclamationIcon className='h-5 w-5' />
      </div>
      <div className="ml-3 flex-1">
        <p className="text-sm text-yellow-700">Beware of scammers. Never give personal details away, and don't send money to anybody you don't trust. Please report scammers.</p>
      </div>
      <button type='button' onClick={() => setClosed(true)} aria-label='Close' className='flex-shrink-0 ml-3 self-start text-yellow-700 hover:text-yellow-900'>
        <XIcon className='h-5 w-5' />
      </button>
    </div>
  </div>
}

export default ScamWarning

ScamWarning.propTypes = {
  text: PropTypes.string
}
